export default __webpack_public_path__ + "static/media/eye-no.744a4ca8.svg";